<template>
  <div class="col-span-12 lg:col-span-6">
    <div class="intro-y box filter-cod">
      <div id="basic-accordion" class="p-5">
        <div id="faq-accordion-1" class="accordion">
          <div class="accordion-item">
            <div id="faq-accordion-content-1" class="accordion-header">
              <button
                class="accordion-button font-poppins font-medium text-base text-theme-1"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq-accordion-collapse-1"
                aria-expanded="true"
                aria-controls="faq-accordion-collapse-1"
                style="
                  font-family: 'Poppins';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 24px;
                  color: black;
                "
              >
                ¿Cuál es el tiempo de entrega de los productos?
              </button>
            </div>
            <div
              id="faq-accordion-collapse-1"
              class="accordion-collapse collapse show"
              aria-labelledby="faq-accordion-content-1"
              data-bs-parent="#faq-accordion-1"
            >
              <div class="accordion-body text-gray-700 leading-relaxed font-poppins">
                <p>Los tiempos de entrega de cada producto son variables, depende del volumen de compra y de la personalización que se requiera. Para conocer más sobre los tiempos de entrega, ponte en contacto con tu ejecutivo de cotizaciones.</p>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <div id="faq-accordion-content-2" class="accordion-header">
              <button
                class="accordion-button collapsed font-poppins font-medium text-base text-theme-1"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq-accordion-collapse-2"
                aria-expanded="false"
                aria-controls="faq-accordion-collapse-2"
                style="
                  font-family: 'Poppins';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 24px;
                  color: black;
                "
              >
                ¿Cómo puedo solicitar un usuario para cotizar?
              </button>
            </div>
            <div
              id="faq-accordion-collapse-2"
              class="accordion-collapse collapse"
              aria-labelledby="faq-accordion-content-2"
              data-bs-parent="#faq-accordion-1"
            >
              <div class="accordion-body text-gray-700 leading-relaxed font-poppins">
                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quaerat minima dolorem quidem, tempore nam assumenda, labore deserunt impedit architecto harum fugiat voluptatibus eius quis? Dolorem repudiandae velit dicta quam cupiditate! </p>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <div id="faq-accordion-content-2" class="accordion-header">
              <button
                class="accordion-button collapsed font-poppins font-medium text-base text-theme-1"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq-accordion-collapse-2"
                aria-expanded="false"
                aria-controls="faq-accordion-collapse-2"
                style="
                  font-family: 'Poppins';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 24px;
                  color: black;
                "
              >
                ¿Cuál es el tiempo de entrega de los productos?
              </button>
            </div>
            <div
              id="faq-accordion-collapse-2"
              class="accordion-collapse collapse"
              aria-labelledby="faq-accordion-content-2"
              data-bs-parent="#faq-accordion-1"
            >
              <div class="accordion-body text-gray-700 leading-relaxed font-poppins ">
                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quaerat minima dolorem quidem, tempore nam assumenda, labore deserunt impedit architecto harum fugiat voluptatibus eius quis? Dolorem repudiandae velit dicta quam cupiditate! </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style scoped>
.filter-cod {
  background: #ffffff00;
  box-shadow: 0 0 0;
}
.form-check-input[type='checkbox'] {
  box-shadow: 0 0 0;
  width: 24px;
  height: 24px;
  border: 1px solid #c4c4c4;
  background: #f1f1f1;
}
.form-check-input[type='checkbox']:checked {
  /* Amarillo */

  background: #faa306;
  /* Amarillo */

  border: 1px solid #faa306;
  border-radius: 4px;
  width: 24px;
  height: 24px;
}

.color-picker {
  box-shadow: 0 0 0;
  width: 24px;
  height: 24px;
  border: none;
  display: inline-block;
  transition: 0.3s all;
}
.color-picker:hover {
  -webkit-box-shadow: inset 0px 0px 0px 4px white;
  -moz-box-shadow: inset 0px 0px 0px 4px white;
  box-shadow: inset 0px 0px 0px 4px white;
}
.color-picker:active {
  -webkit-box-shadow: inset 0px 0px 0px 4px white;
  -moz-box-shadow: inset 0px 0px 0px 4px white;
  box-shadow: inset 0px 0px 0px 4px white;
}
.Aqua{
  background: aqua;
}
.White{
  background: #ffffffd6;
}
.Yellow{
background: #faa306;
}

.Orange {
  background: #E85C04;
}
.Red {
  background: #CE0100;
}
.Beige {
  background: beige;
}
.Gray {
  background: gray;
}
.Pink{
  background: pink;
}
.Green{
  background: green;;
}
.Blue{
background: navy;
}
.Black{
background: black;
}
.Purple{
  background: purple;
}
</style>
